import { formatShiftStartTime } from '../../../utils/rateGuidance';

const DEFAULT_MENU_VIEWPORT_MARGIN = 16;
const MENU_CHROME_GUTTER = 8;

interface FindTempMenuViewportMeasurements {
    headerBottom: number;
    headerHeight: number;
    footerTop: number;
    footerHeight: number;
    viewportHeight: number;
}

/**
 * Reserve vertical space for the larger sticky edge. MaterialSelector handles
 * horizontal bounds separately so this clearance cannot push menus off screen.
 */
export const getFindTempMenuViewportMargin = ({
    headerBottom,
    headerHeight,
    footerTop,
    footerHeight,
    viewportHeight,
}: FindTempMenuViewportMeasurements): number => {
    const occupiedTop = headerHeight > 0
        ? headerBottom + MENU_CHROME_GUTTER
        : DEFAULT_MENU_VIEWPORT_MARGIN;
    const occupiedBottom = footerHeight > 0
        ? Math.max(0, viewportHeight - footerTop) + MENU_CHROME_GUTTER
        : DEFAULT_MENU_VIEWPORT_MARGIN;

    return Math.ceil(Math.max(
        DEFAULT_MENU_VIEWPORT_MARGIN,
        occupiedTop,
        occupiedBottom,
    ));
};

export const formatReviewShiftTime = (value: unknown): string => {
    const normalizedTime = formatShiftStartTime(value);
    if (!normalizedTime) return '—';

    const [hourText, minute] = normalizedTime.split(':');
    const hour = Number(hourText);
    if (!Number.isInteger(hour) || hour < 0 || hour > 23 || !/^\d{2}$/.test(minute)) {
        return '—';
    }

    const period = hour < 12 ? 'am' : 'pm';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minute} ${period}`;
};
